import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, finalize, pipe, tap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
    private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();
    if (token) {
      const modifiedRequest = request.clone({
        setHeaders: {
          'x-access-token': token
        }
      });

      return next.handle(modifiedRequest).pipe(
        tap({
          next: (event) => {},
          error: (_error) => {
            if (_error instanceof HttpErrorResponse && _error.status === 401) {
              this.authService.logout();
              this.router.navigate(['auth/login']);
            }
          }
        }),
      );;
    }

    return next.handle(request);
  }
}
